module.exports = __webpack_public_path__ + "static/media/teen-burger-3-hero-mobile.5c888eb9.jpg";